import { AxiosError } from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../store/auth.slice";
import useNotification from "./useNotification";
import { useTranslation } from "react-i18next";

interface IErrorData {
  message: string;
  data: string;
  error: string;
};

const useAxiosError = (
  error?: AxiosError,
  options?: {
    badRequestMessage?: string;
    unauthorizedMessage?: string;
    ignoreNotFound?: boolean;
    notFoundMessage?: string;
    conflictMessage?: string;
  },
) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { warningNotification, errorNotification } = useNotification();

  const getErrorMessage = (errorData: IErrorData) => {
    return errorData.message || errorData.data || errorData.error || t('common.error.1');
  };

  useEffect(() => {
    if (!error?.response?.status) {
      if (error?.message) {
        errorNotification(error.message);
      }
      return;
    }

    const errorData = error.response?.data as IErrorData;

    switch (error.response.status) {
      case 400:
        warningNotification(
          options?.badRequestMessage ||
          getErrorMessage(errorData)
        );
        break;
      case 401:
        if (options?.unauthorizedMessage) {
          warningNotification(
            options.unauthorizedMessage ||
            getErrorMessage(errorData)
          );
        } else {
          dispatch(logoutSuccess());
        }
        break;
      case 403:
        warningNotification(t('common.message.1'));
        break;
      case 404:
        if (!options?.ignoreNotFound) {
          warningNotification(
            options?.notFoundMessage ||
            t('common.error.2')
          );
        }
        break;
      case 409:
        warningNotification(
          options?.conflictMessage ||
          getErrorMessage(errorData)
        );
        break;  
      default:
        errorNotification(
          getErrorMessage(errorData)
        );
    }
  }, [error]);
};

export default useAxiosError;